import {
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
} from '@mui/material';
import { ImageAspectRatio, ImageOrientation } from '../../../Blocks/BlockImageList/ImageSettings';

interface FixedAspectOptionsProps {
  orientation: ImageOrientation;
  aspectRatio: string;
  handleChangeOrientation: (orientation: ImageOrientation) => void;
  handleChangeAspectRatio: (aspect: ImageAspectRatio) => void;
}

const FixedAspectOptions = ({
  orientation,
  aspectRatio,
  handleChangeOrientation,
  handleChangeAspectRatio,
}: FixedAspectOptionsProps) => (
  <>
    <Grid item sx={{ width: '100%' }}>
      <FormControl>
        <RadioGroup
          name="radio-buttons-group"
          value={orientation}
          onChange={(event) => handleChangeOrientation((event.target as HTMLInputElement).value as ImageOrientation)}
        >
          <FormControlLabel value={ImageOrientation.Square} control={<Radio size="small" />} label="正方形" />
          <FormControlLabel value={ImageOrientation.Landscape} control={<Radio size="small" />} label="横向き" />
          <FormControlLabel value={ImageOrientation.Portrait} control={<Radio size="small" />} label="縦向き" />
        </RadioGroup>
      </FormControl>
    </Grid>

    {orientation !== ImageOrientation.Square && (
      <>
        <Divider sx={{ width: '100%', my: 1 }} />

        <Grid item sx={{ width: '100%' }}>
          <FormControl>
            <RadioGroup
              name="aspect-ratio-radio-buttons-group"
              value={aspectRatio}
              onChange={(event) => handleChangeAspectRatio((event.target as HTMLInputElement).value as ImageAspectRatio)}
            >
              <FormControlLabel value={ImageAspectRatio.FourByThree} control={<Radio size="small" />} label={orientation === ImageOrientation.Landscape ? '４：３' : '３：４'} />
              <FormControlLabel value={ImageAspectRatio.SixteenByNine} control={<Radio size="small" />} label={orientation === ImageOrientation.Landscape ? '１６：９' : '９：１６'} />
            </RadioGroup>
          </FormControl>
        </Grid>
      </>
    )}

  </>
);

export default FixedAspectOptions;
